module.exports = __webpack_public_path__ + "static/6-064ead9b177c137958c93d6c16ae69c1.jpg";